import { render, staticRenderFns } from "./SwitchDemonstrativoField.vue?vue&type=template&id=b1254abc&scoped=true&"
import script from "./SwitchDemonstrativoField.vue?vue&type=script&lang=js&"
export * from "./SwitchDemonstrativoField.vue?vue&type=script&lang=js&"
import style0 from "./SwitchDemonstrativoField.vue?vue&type=style&index=0&id=b1254abc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1254abc",
  null
  
)

export default component.exports